import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "level" }
const _hoisted_2 = { class: "level-right" }
const _hoisted_3 = { class: "level-item" }
const _hoisted_4 = { class: "table is-fullwidth" }

import { appsApi } from '@/features/apps/shared/services/apps';
import { PrivateApp } from '@/features/apps/shared/models';
import { HANDLE_SERIOUS_ERROR } from '@/store/app/actionTypes';
import { useStore } from 'vuex';
import { computed, onBeforeMount, ref } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'PrivateAppsList',
  emits: ["loading", "loaded"],
  setup(__props, { emit: __emit }) {

const store = useStore();
const currentWorkspace = computed(() => store.getters.currentWorkspace);
const handleSeriousError = (error: string) => store.dispatch(HANDLE_SERIOUS_ERROR, error);

const apps = ref<PrivateApp[]>([]);

const emit = __emit;

onBeforeMount(() => {
  emit('loading');
  if (!currentWorkspace.value) {
    handleSeriousError('No workspace selected');
    return;
  }

  appsApi
    .listPrivate(currentWorkspace.value.id)
    .then((loadedApp) => {
      apps.value = loadedApp;
    })
    .catch((err) => {
      handleSeriousError(err.message);
    })
    .finally(() => emit('loaded'));
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("nav", _hoisted_1, [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "level-left" }, null, -1)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", _hoisted_3, [
          _createVNode(_component_router_link, {
            class: "button is-primary",
            to: { name: 'private-apps-create' }
          }, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [
              _createTextVNode("Create New")
            ])),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("table", _hoisted_4, [
      _cache[3] || (_cache[3] = _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("th", null, "Name"),
          _createElementVNode("th", null, " ")
        ])
      ], -1)),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(apps.value, (app) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: app.id
          }, [
            _createElementVNode("td", null, [
              _createVNode(_component_router_link, {
                to: { name: 'private-apps-edit', params: { id: app.id } }
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(app.name), 1)
                ]),
                _: 2
              }, 1032, ["to"])
            ]),
            _cache[2] || (_cache[2] = _createElementVNode("td", null, " ", -1))
          ]))
        }), 128))
      ])
    ])
  ]))
}
}

})